export interface KeyCombo {
    code: string;
    ctrlKey?: boolean;
    altKey?: boolean;
    shiftKey?: boolean;
    metaKey?: boolean;
}

// Returns true if the event matches the specified key combo
export function matchesKeyCombo(
    event: KeyboardEvent,
    combo: KeyCombo
): boolean {
    return (
        event.code === combo.code &&
        !!combo.ctrlKey === event.ctrlKey &&
        !!combo.altKey === event.altKey &&
        !!combo.shiftKey === event.shiftKey &&
        !!combo.metaKey === event.metaKey
    );
}
